module.exports = __webpack_public_path__ + "img/005-ethiopia.d0ca475e.svg";